import React from 'react';
import './GreyButton.css';

export interface Props {
  label: string;
  onClick(): void;
  fullWidth?: boolean;
}

export const GreyButton = (props: Props) => {
  const { label, onClick, fullWidth = false } = props;
  const buttonClass: string = fullWidth ? 'grey-button full-width' : 'grey-button';

  return (
    <button className={buttonClass} type="button" onClick={onClick}>
      <span className="grey-button__text">{label}</span>
    </button>
  );
};
